document.addEventListener('DOMContentLoaded', () => {
  const sizeGuideSelectors = {
    drawer: '#size-guide-drawer',
    link: '.size-guide-link',
  };

  function addSizeGuideEvents() {
    const sizeGuideLinks = document.querySelectorAll(sizeGuideSelectors.link);
    sizeGuideLinks.forEach((link) => {
      link.addEventListener('click', () => {
        closeAllDrawers();
        document.querySelector(sizeGuideSelectors.drawer)?.open();
      });
    });
  }

  document.body.addEventListener('variant:change', addSizeGuideEvents);

  addSizeGuideEvents();
});
